import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

const OrderSuccess = ({ onNewSubmissionClick }) => {
  return (
    <div>
      <p>Twoje zgłoszenie zostało wysłane do parafii.</p>

      <Button type="link" onClick={onNewSubmissionClick}>
        Prześlij kolejne zgłoszenie
      </Button>
    </div>
  );
};

OrderSuccess.propTypes = {
  onNewSubmissionClick: PropTypes.func.isRequired,
};

export default OrderSuccess;
